import React from "react";
import { useT } from "@al/next/al-ex";

import styles from "./index.scss";

export interface ShopInfoType {
  shopName: string;
  shopLogo: string;
  score: string;
  goodsQuantity: number;
}

interface Props {
  shopInfo?: ShopInfoType;
}

const ShopInfo = (props: Props): JSX.Element => {
  const { shopInfo } = props;
  const t = useT();
  return (
    <div className={styles.wrap}>
      <img src={shopInfo?.shopLogo} className={styles.img} />
      <div className={styles.info}>
        <div className={styles.title}>{shopInfo?.shopName}</div>
        <div className={styles.desc}>
          {shopInfo?.score && (
            <div className={styles.rate_box}>
              <span className={styles.value}>{Number(shopInfo.score).toFixed(1)}</span>
              <span className={styles.txt}>{t("评分")}</span>
            </div>
          )}

          <div className={styles.product_box}>
            <span className={styles.value}>{shopInfo?.goodsQuantity}</span>
            <span className={styles.txt}>{t("商品")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ShopInfo;
